export default "__VITE_ASSET__Bfh6Atbe__"